
    const questions = [
      {
        id: 'owner',
        title: 'Bent u eigenaar van de woning?',
        text: 'Piggy Bank richt zich momenteel uitsluitend op woningeigenaren.',
        options: ['Ja', 'Nee']
      },
      {
        id: 'type',
        title: 'Wat voor woning heeft u?',
        text: 'Kies het woningtype dat het beste past.',
        options: ['Appartement', 'Tussenwoning', 'Hoekwoning', '2-onder-1-kap', 'Vrijstaande woning', 'Anders']
      },
      {
        id: 'year',
        title: 'Wat is het bouwjaar van uw woning?',
        text: 'Een schatting is voldoende.',
        options: ['Voor 1975', '1975–1991', '1992–2005', '2006–2015', 'Na 2015', 'Weet ik niet']
      },
      {
        id: 'measures',
        title: 'Welke verduurzamingsmaatregelen heeft u al?',
        text: 'Meerdere antwoorden mogelijk. Vink alles aan wat al aanwezig is.',
        multi: true,
        options: ['Zonnepanelen', 'Warmtepomp', 'Thuisbatterij', 'Goede isolatie', 'Nog niets / beperkt', 'Weet ik niet precies']
      },
      {
        id: 'goal',
        title: 'Wat wilt u vooral bereiken?',
        text: 'Meerdere antwoorden mogelijk. Kies alles wat voor u belangrijk is.',
        multi: true,
        options: ['Lagere energierekening', 'Minder afhankelijk worden', 'Woning toekomstbestendig maken', 'Van het gas af', 'Meer grip op energieverbruik', 'Ik weet niet waar ik moet beginnen']
      },
      {
        id: 'interest',
        title: 'Weet u al welke oplossing u zoekt?',
        text: 'Het is geen probleem als u dat nog niet weet.',
        options: ['Zonnepanelen', 'Thuisbatterij', 'Warmtepomp', 'Combinatie', 'Nee, daarom wil ik advies']
      },
      {
        id: 'bill',
        title: 'Wat betaalt u gemiddeld per maand aan energie?',
        text: 'Een globale inschatting is voldoende.',
        options: ['Minder dan €100', '€100–€200', '€200–€300', '€300–€400', 'Meer dan €400', 'Weet ik niet']
      },
      {
        id: 'timing',
        title: 'Wanneer zou u willen verduurzamen als het advies interessant is?',
        text: 'Zo krijgen we een beeld van uw gewenste tempo.',
        options: ['Zo snel mogelijk', 'Binnen 3 maanden', 'Binnen 6 maanden', 'Binnen 12 maanden', 'Alleen oriënteren']
      },
      {
        id: 'finance',
        title: 'Hoe wilt u een eventuele verduurzaming financieren?',
        text: 'Piggy Bank kan ook begeleiden bij het verkennen van financieringsmogelijkheden.',
        options: ['Eigen middelen', 'Financiering', 'Combinatie van beide', 'Weet ik nog niet / advies gewenst']
      }
    ];

    let index = 0;
    const answers = {};
    const area = document.getElementById('questionArea');
    const progress = document.getElementById('progressBar');

    function renderQuestion() {
      const q = questions[index];
      progress.style.width = `${((index + 1) / questions.length) * 100}%`;
      const currentAnswer = answers[q.id];
      const hasAnswer = q.multi
        ? Array.isArray(currentAnswer) && currentAnswer.length > 0
        : Boolean(currentAnswer);

      area.innerHTML = `
        <div class="question active">
          <div class="mini" style="font-weight:900;margin-bottom:8px">Vraag ${index + 1} van ${questions.length}</div>
          <h3>${q.title}</h3>
          <p>${q.text}</p>
          <div class="options">
            ${q.options.map(opt => {
              const selected = q.multi
                ? Array.isArray(currentAnswer) && currentAnswer.includes(opt)
                : currentAnswer === opt;
              return `<button class="option ${selected ? 'selected' : ''}" data-value="${opt}" aria-pressed="${selected}">${opt}${selected && q.multi ? ' ✓' : ''}</button>`;
            }).join('')}
          </div>
          <div class="form-actions">
            <button class="btn btn-light" ${index === 0 ? 'disabled style="opacity:.45;cursor:not-allowed"' : ''} id="prevBtn">Terug</button>
            <button class="btn btn-primary" id="nextBtn" ${hasAnswer ? '' : 'disabled style="opacity:.45;cursor:not-allowed"'}>${index === questions.length - 1 ? 'Bekijk resultaat' : 'Volgende'}</button>
          </div>
        </div>`;

      area.querySelectorAll('.option').forEach(btn => {
        btn.addEventListener('click', () => {
          const value = btn.dataset.value;

          if (q.multi) {
            const exclusive = ['Nog niets / beperkt', 'Weet ik niet precies'];
            let selected = Array.isArray(answers[q.id]) ? [...answers[q.id]] : [];

            if (exclusive.includes(value)) {
              selected = selected.includes(value) ? [] : [value];
            } else {
              selected = selected.filter(item => !exclusive.includes(item));
              selected = selected.includes(value)
                ? selected.filter(item => item !== value)
                : [...selected, value];
            }
            answers[q.id] = selected;
          } else {
            answers[q.id] = value;
          }

          // Harde kwalificatie: Piggy Bank is uitsluitend voor woningeigenaren.
          if (q.id === 'owner' && value === 'Nee') {
            showIneligibleOwner();
            return;
          }

          renderQuestion();
        });
      });

      const prev = document.getElementById('prevBtn');
      if (prev && index > 0) prev.addEventListener('click', () => { index--; renderQuestion(); });

      const next = document.getElementById('nextBtn');
      if (next) next.addEventListener('click', () => {
        const answer = answers[q.id];
        const valid = q.multi ? Array.isArray(answer) && answer.length > 0 : Boolean(answer);
        if (!valid) return;
        if (index < questions.length - 1) { index++; renderQuestion(); }
        else finishQuiz();
      });
    }


    function showIneligibleOwner() {
      area.style.display = 'none';
      progress.style.display = 'none';
      document.getElementById('eligibleResult').classList.remove('active');
      document.getElementById('detailsStep').classList.remove('active');
      document.getElementById('ineligibleResult').classList.add('active');
    }

    function finishQuiz() {
      area.style.display = 'none';
      progress.style.display = 'none';

      const eligible = answers.owner === 'Ja';
      document.getElementById(eligible ? 'eligibleResult' : 'ineligibleResult').classList.add('active');
      if (eligible) bindDetailsButton();
    }

    function restartQuiz() {
      Object.keys(answers).forEach(k => delete answers[k]);
      index = 0;
      document.getElementById('eligibleResult').classList.remove('active');
      document.getElementById('ineligibleResult').classList.remove('active');
      document.getElementById('detailsStep').classList.remove('active');
      area.style.display = 'block';
      progress.style.display = 'block';
      renderQuestion();
    }

    function bindDetailsButton() {
      const btn = document.getElementById('detailsButton');
      if (!btn) return;
      btn.onclick = () => {
        document.getElementById('eligibleResult').classList.remove('active');
        document.getElementById('detailsStep').classList.add('active');
      };
    }

    document.getElementById('backToResult').addEventListener('click', () => {
      document.getElementById('detailsStep').classList.remove('active');
      document.getElementById('eligibleResult').classList.add('active');
      bindDetailsButton();
    });


    // Automatische Nederlandse adresherkenning via de gratis PDOK Locatieserver.
    const postcodeInput = document.getElementById('postcode');
    const houseNumberInput = document.getElementById('houseNumber');
    const addressInput = document.getElementById('address');
    const addressStatus = document.getElementById('addressStatus');
    const addressHelp = document.getElementById('addressHelp');
    let addressLookupTimer;

    function normalizePostcode(value) {
      const compact = value.toUpperCase().replace(/\s+/g, '');
      if (/^\d{4}[A-Z]{2}$/.test(compact)) {
        return compact.slice(0, 4) + ' ' + compact.slice(4);
      }
      return value.toUpperCase();
    }

    function setAddressState(state, message = '') {
      if (state === 'loading') {
        addressStatus.textContent = '…';
        addressHelp.textContent = 'Adres wordt opgezocht…';
        addressInput.style.background = '#f7f8f6';
      } else if (state === 'success') {
        addressStatus.textContent = '✓';
        addressHelp.textContent = 'Adres automatisch gevonden.';
        addressInput.style.background = '#f2faf2';
      } else if (state === 'error') {
        addressStatus.textContent = '!';
        addressHelp.textContent = message || 'Adres niet gevonden. Controleer postcode en huisnummer of vul het adres handmatig in.';
        addressInput.style.background = '#fff7f7';
      } else {
        addressStatus.textContent = '';
        addressHelp.textContent = 'Vul postcode en huisnummer in. Het adres wordt automatisch opgezocht.';
        addressInput.style.background = '#f7f8f6';
      }
    }

    async function lookupAddress() {
      const postcodeRaw = postcodeInput.value.trim();
      const houseNumber = houseNumberInput.value.trim();
      const postcodeCompact = postcodeRaw.toUpperCase().replace(/\s+/g, '');

      if (!/^\d{4}[A-Z]{2}$/.test(postcodeCompact) || !houseNumber) {
        addressInput.value = '';
        setAddressState('idle');
        return;
      }

      postcodeInput.value = normalizePostcode(postcodeCompact);
      setAddressState('loading');

      const query = encodeURIComponent(`${postcodeCompact} ${houseNumber}`);
      const url = `https://api.pdok.nl/bzk/locatieserver/search/v3_1/free?q=${query}&fq=type:adres&rows=1`;

      try {
        const response = await fetch(url, { headers: { 'Accept': 'application/json' } });
        if (!response.ok) throw new Error('Adresservice niet bereikbaar');

        const data = await response.json();
        const doc = data?.response?.docs?.[0];

        if (!doc) {
          addressInput.value = '';
          setAddressState('error');
          return;
        }

        const foundPostcode = String(doc.postcode || '').replace(/\s+/g, '').toUpperCase();
        if (foundPostcode && foundPostcode !== postcodeCompact) {
          addressInput.value = '';
          setAddressState('error', 'Geen exact adres gevonden voor deze postcode en dit huisnummer.');
          return;
        }

        const street = doc.straatnaam || doc.openbareruimtenaam || '';
        const city = doc.woonplaatsnaam || '';
        const displayAddress = [street, houseNumber, city].filter(Boolean).join(', ');

        if (!displayAddress) {
          addressInput.value = '';
          setAddressState('error');
          return;
        }

        addressInput.value = displayAddress;
        setAddressState('success');
      } catch (error) {
        addressInput.value = '';
        setAddressState('error', 'Automatisch opzoeken lukt nu niet. Je kunt het adres handmatig invullen.');
      }
    }

    function scheduleAddressLookup() {
      clearTimeout(addressLookupTimer);
      addressLookupTimer = setTimeout(lookupAddress, 450);
    }

    postcodeInput.addEventListener('input', () => {
      postcodeInput.value = postcodeInput.value.toUpperCase();
      scheduleAddressLookup();
    });
    postcodeInput.addEventListener('blur', () => {
      postcodeInput.value = normalizePostcode(postcodeInput.value);
      lookupAddress();
    });
    houseNumberInput.addEventListener('input', scheduleAddressLookup);
    houseNumberInput.addEventListener('blur', lookupAddress);


    const salutationInput = document.getElementById('salutation');
    document.querySelectorAll('.salutation-option').forEach((button) => {
      button.addEventListener('click', () => {
        document.querySelectorAll('.salutation-option').forEach((item) => item.classList.remove('selected'));
        button.classList.add('selected');
        salutationInput.value = button.dataset.value;
      });
    });

    document.getElementById('toCheckout').addEventListener('click', async () => {
      const required = ['firstName','lastName','email','phone','postcode','houseNumber','address'];
      const ok = required.every(id => document.getElementById(id).value.trim()) &&
                 document.getElementById('email').checkValidity() &&
                 document.getElementById('privacyConsent').checked &&
                 document.getElementById('termsConsent').checked;
      document.getElementById('detailsError').style.display = ok ? 'none' : 'block';
      if (!ok) return;

      const root = document.getElementById('PiggyBankPage');
      const variantId = Number(root?.dataset.variantId || 0);
      const isAvailable = root?.dataset.productAvailable === 'true';
      const checkoutButton = document.getElementById('toCheckout');
      if (!variantId || !isAvailable) {
        document.getElementById('detailsError').textContent = 'Het adviesproduct is nog niet gekoppeld of niet beschikbaar. Neem contact op met Piggy Bank.';
        document.getElementById('detailsError').style.display = 'block';
        return;
      }

      const customer = Object.fromEntries(required.map(id => [id, document.getElementById(id).value.trim()]));
      const answerLabels = {
        owner:'Woningeigenaar', type:'Woningtype', year:'Bouwjaar', gas:'Gasverbruik', electricity:'Stroomverbruik', energyBill:'Energierekening', solar:'Zonnepanelen', heating:'Verwarming', goal:'Doel'
      };
      const properties = {
        '_PB Aanhef': document.getElementById('salutation').value || '',
        '_PB Voornaam': customer.firstName,
        '_PB Achternaam': customer.lastName,
        '_PB E-mail': customer.email,
        '_PB Telefoon': customer.phone,
        '_PB Postcode': customer.postcode,
        '_PB Huisnummer': customer.houseNumber,
        '_PB Adres': customer.address,
        '_PB Privacy gelezen': 'Ja',
        '_PB Voorwaarden akkoord': 'Ja',
        '_PB Start tijdens bedenktijd': document.getElementById('earlyStartConsent').checked ? 'Ja' : 'Nee'
      };
      Object.entries(answers).forEach(([key,value]) => {
        properties['_PB ' + (answerLabels[key] || key)] = String(value);
      });

      localStorage.setItem('piggyBankQualification', JSON.stringify({answers, customer, agreement: {termsAccepted: true, earlyStartRequested: document.getElementById('earlyStartConsent').checked, product: 'Piggy Bank Adviestraject'}}));
      checkoutButton.disabled = true;
      const originalText = checkoutButton.textContent;
      checkoutButton.textContent = 'Even geduld…';
      try {
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
          method: 'POST',
          headers: {'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({items:[{id:variantId,quantity:1,properties}]})
        });
        if (!response.ok) throw new Error('Toevoegen aan winkelmand mislukt');
        window.location.assign((window.Shopify?.routes?.root || '/') + 'checkout');
      } catch (error) {
        document.getElementById('detailsError').textContent = 'Betalen kon niet worden gestart. Probeer het opnieuw of neem contact met ons op.';
        document.getElementById('detailsError').style.display = 'block';
        checkoutButton.disabled = false;
        checkoutButton.textContent = originalText;
      }
    });

    renderQuestion();
  

(function(){
  const q=id=>document.getElementById(id);
  let apiReady=false;
  function showBanner(editing){
    const b=q('cookieBanner'); if(!b)return;
    b.classList.add('show'); q('cookieSettingsButton')?.classList.remove('show');
    if(editing) q('cookiePrefs')?.classList.add('open');
  }
  function hideBanner(){ q('cookieBanner')?.classList.remove('show'); q('cookieSettingsButton')?.classList.add('show'); }
  function openLegal(kind){ q(kind==='privacy'?'privacyModal':'cookiesModal')?.classList.add('open'); }
  function closeLegal(el){ el.closest('.legal-modal')?.classList.remove('open'); }
  function setSwitches(consent){
    if(!consent)return;
    if(q('analyticsConsent')) q('analyticsConsent').checked = consent.analytics === 'yes' || consent.analytics === true;
    if(q('marketingConsent')) q('marketingConsent').checked = consent.marketing === 'yes' || consent.marketing === true;
  }
  function saveConsent(values){
    if(apiReady && window.Shopify?.customerPrivacy){
      window.Shopify.customerPrivacy.setTrackingConsent(values, hideBanner);
    } else {
      localStorage.setItem('piggyBankConsentFallback', JSON.stringify(values));
      hideBanner();
    }
    window.piggyBankConsent=values;
    window.dispatchEvent(new CustomEvent('piggybank:consent',{detail:values}));
  }
  function initPrivacy(){
    if(window.Shopify?.loadFeatures){
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], function(error){
        if(!error && window.Shopify?.customerPrivacy){
          apiReady=true;
          const current=window.Shopify.customerPrivacy.currentVisitorConsent();
          setSwitches(current);
          if(window.Shopify.customerPrivacy.shouldShowBanner()) showBanner(false); else q('cookieSettingsButton')?.classList.add('show');
        } else initFallback();
      });
    } else initFallback();
  }
  function initFallback(){
    try{
      const saved=JSON.parse(localStorage.getItem('piggyBankConsentFallback')||'null');
      if(saved){setSwitches(saved);q('cookieSettingsButton')?.classList.add('show')}else showBanner(false);
    }catch(e){showBanner(false)}
  }
  document.querySelectorAll('[data-legal]').forEach(el=>el.addEventListener('click',()=>openLegal(el.dataset.legal)));
  document.querySelectorAll('.legal-close').forEach(el=>el.addEventListener('click',()=>closeLegal(el)));
  document.querySelectorAll('.legal-modal').forEach(el=>el.addEventListener('click',e=>{if(e.target===el)el.classList.remove('open')}));
  q('acceptAllCookies')?.addEventListener('click',()=>saveConsent({analytics:true,marketing:true,preferences:true}));
  q('rejectOptionalCookies')?.addEventListener('click',()=>saveConsent({analytics:false,marketing:false,preferences:false}));
  q('saveCookiePrefs')?.addEventListener('click',()=>saveConsent({analytics:!!q('analyticsConsent')?.checked,marketing:!!q('marketingConsent')?.checked,preferences:true}));
  q('openCookiePrefs')?.addEventListener('click',()=>q('cookiePrefs')?.classList.toggle('open'));
  q('cookieSettingsButton')?.addEventListener('click',()=>showBanner(true));
  q('footerCookieSettings')?.addEventListener('click',()=>showBanner(true));
  initPrivacy();
})();
